import { useState } from 'react'
import { toast } from 'react-toastify'

import { useThunkDispatch } from '@campaignhub/react-hooks'

import { deleteAssetVersion, loadAssets } from '@redux/modules/asset'

const ASSET_INCLUDES = ['comments.createdBy', 'histories.createdBy, file.filePreviewRequests'].join(',')

const useAssetVersionDeletion = (assetId, serviceJobId) => {
  const dispatch = useThunkDispatch()

  const [deleting, setDeleting] = useState(false)

  const deleteVersion = async (version) => {
    setDeleting(true)

    const { success, errors } = await dispatch(deleteAssetVersion(assetId, version))

    if (success){
      await dispatch(loadAssets({ serviceJobs: serviceJobId, includes: ASSET_INCLUDES }))
      setDeleting(false)
      toast.success('Version deleted')
      return { success }
    }

    setDeleting(false)
    toast.error(errors?.[0] || 'Couldn\'t delete the version. Please try again.')
    return { success }
  }

  return { deleting, deleteVersion }
}

export default useAssetVersionDeletion
